import "../../css/components/Text.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Parser } from "html-to-react";
import g from "../utils/globals";

const htmlParser = new Parser(React);

class Text extends Component {
  componentDidMount = () => {
    if (g.eagerMode) {
      g.renderingCheck.add(this.props.text);
    }
  };
  createElement = () => {
    const tag = this.props.element || "p";

    const rawHtml = /<br>/.test(this.props.text) ? this.props.text : this.props.text.replace(/(?:\r+\n|\r|\n)/g, "<br>");
    const text = htmlParser.parse(rawHtml);

    const styles = this.props.styles;

    if (
      g.editMode &&
      g.channels.mobile &&
      styles.fontSize &&
      styles.fontSize.indexOf("vw") > 0 &&
      document.getElementById("home-mobile-wrapper")
    ) {
      const fontSize = parseFloat(styles.fontSize.replace("vw", ""));
      const finalSize = (fontSize * document.getElementById("home-mobile-wrapper").clientWidth) / 100 / 1.05;
      styles.fontSize = `${finalSize}px`;
    }

    // EDIT MODE CHANGE COLOR TO DIV NOT TEXT
    if (this.props.cell) delete styles.color;

    const attrs = {
      ...this.props.attrs,
    };
    switch (tag) {
      case "h1":
        return (
          <h1 {...attrs} style={{ ...styles }}>
            {text}
          </h1>
        );
      case "div":
        return (
          <div {...attrs} style={{ ...styles }}>
            <h1>{text}</h1>
          </div>
        );
      case "p":
        return (
          <p {...attrs} style={{ ...styles }}>
            {text}
          </p>
        );
      default:
        return (
          <span {...attrs} style={{ ...styles }}>
            {text}
          </span>
        );
    }
  };

  render = () => this.createElement();
}

Text.defaultProps = {
  attributes: {},
  content: "",
  attrs: {},
  styles: {},
};

Text.propTypes = {
  attributes: PropTypes.object,
  content: PropTypes.string.isRequired,
  attrs: PropTypes.object,
  styles: PropTypes.object,
};

export default Text;
